<mat-list-item [ngStyle]="{'padding-left': (depth ? depth * 12: 12) + 'px'}" (click)="onItemSelected(item)"
   [ngClass]="{'active menu-list-item-selected': item.route ? router.isActive(item.route, true): false, 'expanded': expanded}">
  {{item.displayName}}

  <div fxFlex *ngIf="item.children && item.children.length" style="width: 100%;">
    <mat-icon mat-list-icon [@indicatorRotate]="expanded ? 'expanded': 'collapsed'" style="float: right; margin-right: 10px;}">
      expand_more
    </mat-icon>
  </div>
</mat-list-item>
<div *ngIf="expanded">
  <app-menu-list-item *ngFor="let child of item.children" class="nav-item-child" [item]="child" [depth]="depth ? depth + 1: 2">
  </app-menu-list-item>
</div>
